var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcDashboardHover = function SvgIcDashboardHover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_dashboard",
    "data-name": "icon - dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    d: "M2,0H7A0,0,0,0,1,7,0V9A0,0,0,0,1,7,9H0A0,0,0,0,1,0,9V2A2,2,0,0,1,2,0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    d: "M0,0H5A2,2,0,0,1,7,2V6A0,0,0,0,1,7,6H0A0,0,0,0,1,0,6V0A0,0,0,0,1,0,0Z",
    transform: "translate(11)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    d: "M0,0H7A0,0,0,0,1,7,0V5A0,0,0,0,1,7,5H2A2,2,0,0,1,0,3V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 13)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    d: "M0,0H7A0,0,0,0,1,7,0V6A2,2,0,0,1,5,8H0A0,0,0,0,1,0,8V0A0,0,0,0,1,0,0Z",
    transform: "translate(11 10)",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcDashboardHover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_dashboard_hover.10c34d1076d5cfd443aafb38783e1b09.svg";